import React,{useState} from 'react';
import Wrp from '../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
import { callGET, callPOST, callPUT, callDELETE } from '../../../Utils/ApiUtil';
import * as ShipConstants from '../../../Global/Constants';

const EditTerritoryUsers = (props) => {
  const curState = props.curState;
  const editData = curState.editData;
  // console.log(editData);

  return (
    <Modal size="lg" show={props.modelOpen} onHide={props.toggleModel}>
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2"> Edit <span className="ml-2 badge badge-info"> Forecast Name & Year </span>  </h5>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <h6> Target for Sub-territories </h6>
                  </div>

                  <div className="form-group">
                    <div className="table-responsive ">
                      <div className="table-scroll">
                        <table className="table mb-0">
                           
                          <thead>
                            <tr className="border-top"> 
                              <th> Target Name </th>
                              <th> Territory Target </th>
                              {/*<th> Manager Target </th> */} 
                            </tr>
                          </thead>
                          <tbody>
                          {
                            editData ?
                              editData.map((arr,i) => {
                                return (
                                  <tr>
                                    <td> <a> <span className="badge badge-info"> {arr.user_name} </span>   </a> </td>
                                    <td> <input type="text" name="target_value" value={arr.target_value} onChange={e=>props.editTerritoryChangeHandler(e,i)} className="form-control form-control-sm" />  </td>
                                    {/*<td> <input type="" name="" className="form-control form-control-sm" /> </td> */}
                                  </tr>
                                )
                              })
                            : null
                          }
                          </tbody>
                                                 
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
               <div className="ml-md-auto py-2 py-md-0">
                  <a onClick={e=>props.toggleModel(null)} className="btn btn-border border-default mr-2" data-dismiss="modal"> Cancel </a> 
                  <a onClick={e=>props.updateHandler('users')} className="btn primary_bg"> Save </a>
                    
                </div>
            </Modal.Footer>
    </Modal>
  );
}

export default withRouter(EditTerritoryUsers);